(function (angular, _, window) {
    'use strict';

    /**
     * Gets the list of Services that are attached to the service type.
     */
    window.THF.Angular.API
        .factory('RebatePDFModel', ['$http', '$q', function ($http, $q) {
            var RebatePDFModel = function () {

            };

            RebatePDFModel.prototype = {
                /**
                 * @returns {deferred.promise|{then, always}}
                 */
                render: function (rebateData) {
                    var deferred = $q.defer();

                    $http({
                        method: 'POST',
                        url: '/api/v1/generate-rebate-declaration-render',
                        data: rebateData,
                        responseType: 'blob'
                    }).then(
                        function successCallback(response) {
                            var data = response.data;
                            deferred.resolve(data);
                        },
                        function errorCallback() {
                            deferred.reject({ result: false, message: 'Unable to generate the rebate pdf.' });
                        }
                    );
                    return deferred.promise;
                }

            };
            return new RebatePDFModel();
        }]);
})(angular, _, window);
